import { render } from "./ShowHtml.vue?vue&type=template&id=9a1883aa"
import script from "./ShowHtml.vue?vue&type=script&lang=js"
export * from "./ShowHtml.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__